import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      stickerMemoList: [],
      showMemo: false,
      maxCount: 30,
      activeMemoUniqueKey: null,
      coordinateObject: {}
    };
  },
  computed: {
    ...mapGetters(['getAccountId', 'isLoggedIn', 'getNotepadOn']),
    hasMaxCount() {
      return this.stickerMemoList.length >= this.maxCount;
    },
    unsavedMemoList() {
      return this.stickerMemoList.filter((memo) => memo.isSaved !== undefined && memo.isSaved === false);
    }
  },
  watch: {
    isLoggedIn(val) {
      if (!val) {
        this.resetMemoInfo();
      }
    },
    getNotepadOn(on) {
      if (on) {
        this.getMemoList();
      } else {
        this.saveMemoInfo();
        this.showMemo = false;
      }
    }
  },
  created() {
    this.$eventBus.$on('change-notepad-on', (notepadOn) => {
      if (notepadOn !== this.showMemo) {
        this.patchNotepadOn(notepadOn);
      }
    });
  },
  methods: {
    resetMemoInfo() {
      this.showMemo = false;
      this.initMemoList();
      this.coordinateObject = {};
      this.activeMemoUniqueKey = null;
    },
    patchNotepadOn(notepadOn) {
      if (notepadOn) {
        this.patchNotepadSettings(notepadOn);
      } else {
        if (this.unsavedMemoList.length) {
          this.$confirmMsg(
            '',
            '저장되지 않은 메모가 있습니다.<br/>지금 종료하면 입력된 메모는 저장되지 않습니다.<br/>지금 종료하시겠습니까?',
            () => {
              this.patchNotepadSettings(notepadOn);
            },
            '종료'
          );
        } else {
          this.patchNotepadSettings(notepadOn);
        }
      }
    },
    patchNotepadSettings(notepadOn) {
      this.$http({
        url: `/api/v1/accounts/${this.getAccountId}/notepad-settings`,
        method: 'PATCH',
        data: {
          notepadOn
        }
      })
        .then(() => {
          this.$store.commit('changeNotepadOn', notepadOn);
        })
        .catch((err) => {
          this.$alertMsg(err.message);
        });
    },
    initMemoList() {
      this.stickerMemoList = [];
    },
    defaultMemoItem() {
      return {
        index: `${this.$uuid.v1()}`,
        content: '',
        date: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        isEdited: false,
        isSaved: false,
        x: 0,
        y: 0,
        z: 15,
        isFolded: false,
        isLock: false,
        isAutoSave: false,
        width: 450,
        height: 300,
        isCopied: false
      };
    },
    saveMemoInfo() {
      // 메모의 좌표 및 메모 내 내용 제외한 부가적인 정보 저장해놓기 위함
      if (this.stickerMemoList.length) {
        const savedMemoList = this.stickerMemoList.filter((i) => !!i.id);

        if (savedMemoList.length) {
          this.coordinateObject = {};
          savedMemoList.forEach((i) => {
            this.coordinateObject[i.id] = {
              id: i.id,
              x: i.x,
              y: i.y,
              z: i.z,
              isFolded: i.isFolded,
              isLock: i.isLock,
              width: i.width,
              height: i.height
            };
          });
        }
      }
    },
    getMemoInfo(item, key) {
      return (this.coordinateObject[item.id] && this.coordinateObject[item.id][key]) || null;
    },
    getMemoList() {
      if (!this.getAccountId) {
        return;
      }

      this.initMemoList();
      this.$http({
        url: `/api/v1/accounts/${this.getAccountId}/notepads`,
        method: 'GET'
      })
        .then((result) => {
          const data = result.data;
          if (data && data.length) {
            this.stickerMemoList = data.map((i) => {
              const x = this.getMemoInfo(i, 'x');
              const y = this.getMemoInfo(i, 'y');
              const z = this.getMemoInfo(i, 'z');
              const isFolded = this.getMemoInfo(i, 'isFolded');
              const isLock = this.getMemoInfo(i, 'isLock');
              return {
                id: i.id,
                content: i.content,
                width: i.width,
                height: i.height,
                isSaved: true,
                isEdited: false,
                isAutoSave: false,
                isCopied: false,
                x: x !== null ? x : i.pointX !== null ? i.pointX : 0,
                y: x !== null ? y : i.pointY !== null ? i.pointY : 0,
                z: z !== null ? z : i.pointZ !== null ? i.pointZ : 15,
                isFolded: isFolded !== null ? isFolded : i.minimization ? i.minimization : false,
                isLock: isLock !== null ? isLock : i.locked
              };
            });
          }
          if (!this.stickerMemoList.length) {
            this.addMemo();
          }
          this.showMemo = true;
        })
        .catch((err) => {
          this.$alertMsg(err.message);
        });
    },
    copyMemo(item) {
      if (this.hasMaxCount) {
        return;
      }

      this.addMemo({ ...item, id: null });
    },
    deleteMemoPopup(item) {
      this.$confirmMsg(
        '',
        '등록된 메모가 삭제됩니다.<br/>메모를 삭제하시겠습니까?',
        () => {
          this.deleteMemo(item);
        },
        '삭제'
      );
    },
    deleteMemo(item) {
      if (item && item.id) {
        this.$http({
          url: `/api/v1/notepads/${item.id}`,
          method: 'DELETE'
        })
          .then(() => {
            this.findAndExecute(item, (findIndex) => {
              this.stickerMemoList.splice(findIndex, 1);
              if (!this.stickerMemoList.length) {
                this.showMemo = false;
                this.patchNotepadSettings(this.showMemo);
              }
            });
          })
          .catch((err) => {
            this.$alertMsg(err.message);
          });
      } else {
        this.findAndExecute(item, (findIndex) => {
          this.stickerMemoList.splice(findIndex, 1);
          if (!this.stickerMemoList.length) {
            this.showMemo = false;
            this.patchNotepadSettings(this.showMemo);
          }
        });
      }
    },
    findAndExecute(item, callback) {
      const findIndex = this.stickerMemoList.findIndex(
        (memo) => (memo.id && item.id && memo.id === item.id) || (memo.index && item.index && memo.index === item.index)
      );
      if (findIndex !== -1) {
        callback(findIndex);
      }
    },
    updateMemoList(item) {
      this.findAndExecute(item, (findIndex) => {
        this.stickerMemoList.splice(findIndex, 1, item);
      });
    },
    saveMemo(item) {
      if (!this.getAccountId || (!item.id && !item.content)) {
        return;
      }

      this.$http({
        url: item.id ? `/api/v1/notepads/${item.id}` : `/api/v1/accounts/${this.getAccountId}/notepads`,
        method: item.id ? 'PATCH' : 'POST',
        data: {
          content: item.content,
          pointX: item.x,
          pointY: item.y,
          pointZ: item.z,
          minimization: item.isFolded,
          locked: item.isLock,
          width: item.width,
          height: item.height
        }
      })
        .then((result) => {
          if (result.data) {
            const updatedMemo = result.data;
            this.updateMemoList({
              index: item.index,
              id: updatedMemo.id,
              content: updatedMemo.content,
              width: updatedMemo.width,
              height: updatedMemo.height,
              x: item.x,
              y: item.y,
              z: item.z,
              isFolded: item.isFolded,
              isLock: item.isLock,
              isEdited: false,
              isSaved: true,
              isAutoSave: false,
              isCopied: false
            });
          }
        })
        .catch(() => {
          if (!item.isAutoSave) {
            this.$alertMsg('메모가 저장되지 않았습니다.<br/>다시 한번 시도해 주시길 바랍니다.');
          }
        });
    },
    addMemo(item) {
      if (this.hasMaxCount) {
        return;
      }
      const newItem = this.defaultMemoItem();
      if (item) {
        this.stickerMemoList.push({ ...newItem, content: item.content, id: item.id, isCopied: item.isCopied });
      } else {
        this.stickerMemoList.push(newItem);
      }
      this.activeMemo(newItem);
      return newItem;
    },
    activeMemo(item) {
      this.activeMemoUniqueKey = item.id || item.index;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/memo.js